module.exports = __webpack_public_path__ + "static/img/head2.93e6b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/head2.png
// module id = ia/X
// module chunks = 2